// Read the per-render user-socket token rendered into root.html.heex.
//
// `UserSocket.connect/3` rejects every WebSocket connect that lacks a signed
// token, so any caller that opens `/ci/socket` MUST pass the value returned
// here as `params: { token }`. Anonymous renders deliberately omit the meta
// tag — the function returns null and the resulting socket will fail every
// channel join, which is the desired behavior.
export const readUserSocketToken = (
  doc: Document = document,
): string | null => {
  const el = doc.querySelector<HTMLMetaElement>(
    'meta[name="user-socket-token"]',
  );
  return el?.content ?? null;
};
